import React, { useEffect, useState } from "react";
import DialogForm from "@/components/modal/DialogForm";
import { IconButton } from "@mui/material";
import ViewHoliday from "../master/component/ViewHoliday";
import EventCalendar from "../master/component/EventCalendar";
import { Box } from "@mui/system";
import CardHeader from "@/components/card/CardHeader";
import { Legend } from "@/components";
import Filter from "../master/component/Filter";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  useFetchAllHolidaysQuery,
  useFetchSettingsQuery,
  useFetchStateQuery,
} from "@/api/services/holiday/AllHolidays";
import { set } from "lodash";

const ViewAll = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [hideBtn, setHideBtn] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [selectedYearMonth, setSelectedYearMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [selectedValues, setSelectedValues] = useState({
    month: "",
    state: "",
    location: "",
    type: "",
  });
  console.log("locationOptions");

  const { data: locationOptions = [] } = useFetchSettingsQuery({
    referenceName: "Work Location",
  });

  const {
    data: allHolidays = [],
    isLoading,
    isError,
  } = useFetchAllHolidaysQuery({
    state: selectedValues.state,
    location: selectedValues.location,
    month: selectedYearMonth,
  });
  const { data: stateOptions = [] } = useFetchStateQuery("India");

  // click on event
  const handleEventClick = (info) => {
    setSelectedEvent(info?.event?._def?.extendedProps);
    setOpenDialog(true);
    setHideBtn(true);
  };
  const transformedStateOptions = stateOptions.map((item, index) => ({
    key: `${item.stateCode}-${index}`,
    value: item.name,
    label: item.name,
  }));
  const transformedLocationOptions = locationOptions.map((item, index) => ({
    value: item.name,
    label: item.name,
  }));

  // close the modal
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedEvent(null);
  };

  const toggleFilter = () => {
    setFilterVisible(!filterVisible);
  };

  const handleFilterChange = (filterKey, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [filterKey]: value,
    }));
    console.log(`Filter ${filterKey} changed to ${value}`);
  };

  const stateOptions1 = [
    { value: "Karnataka", label: "Karnataka" },
    { value: "Anthra", label: "Anthra" },
    { value: "kerala", label: "Kerala" },
    { value: "Bangalore", label: "Bangalore" },
    { value: "Andhra", label: "Andhra" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "test", label: "test" },
    { value: "Tamilnadu", label: "Tamilnadu" },
    { value: "Kerala", label: "Kerala" },
    { value: "Aaaa", label: "Aaaa" },
    { value: "Puducherry", label: "Puducherry" },
    { value: "VILLUPURAM", label: "VILLUPURAM" },
  ];

  const locationOptions1 = [
    { value: "Onsite - Villupuram", label: "Onsite - Villupuram" },
    {
      value: "Others - Plant / Field / Other Offices",
      label: "Others - Plant / Field / Other Offices",
    },
    { value: "Work From Home", label: "Work From Home" },
    { value: "Onsite - Chennai", label: "Onsite - Chennai" },
    { value: "Onsite - Cuddalore", label: "Onsite - Cuddalore" },
    { value: "Onsite - Bengaluru", label: "Onsite - Bengaluru" },
  ];

  const eventContent = (eventInfo) => {
    const { backgroundColor, textColor, width, height, borderRadius } =
      eventInfo.event.extendedProps;

    return (
      <div
        className="custom-event"
        style={{
          backgroundColor: backgroundColor,
          color: textColor,
          width: width,
          height: height,
          lineHeight: height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: borderRadius,
        }}
      >
        {eventInfo.event.title}
      </div>
    );
  };

  const filterOptions = {
    state: transformedStateOptions,
    location: transformedLocationOptions,
  };

  const buttons = [
    {
      type: "reset",
      label: "Reset",
      variant: "contained",
      customvariant: "delete",
      size: "medium",
    },
  ];

  const responseData = [
    {
      title: "Holiday",
      start: "2024-08-06",
      description: "Independence Day",
      id: "66c2dbe120571127949dc07e",
      occassion: "Independence Day",
      restrictedHoliday: "No",
      allState: true,
      allLocation: true,
      stateList: [
        "Karnataka",
        "Anthra",
        "kerala",
        "Bangalore",
        "Andhra",
        "Tamil Nadu",
        "test",
        "Tamilnadu",
        "Kerala",
        "Aaaa",
        "Puducherry",
        "VILLUPURAM",
      ],
      locations: [
        "Onsite - Villupuram",
        "Others - Plant / Field / Other Offices",
        "Work From Home",
        "Onsite - Chennai",
        "Onsite - Cuddalore",
        "Onsite - Bengaluru",
      ],
    },
    {
      title: "Restricted Holiday",
      start: "2024-08-07",
      description: "Pondycherry Independence Day",
      id: "66c2dbe120571127949dc07e",
      occassion: "Independence Day",
      restrictedHoliday: "Yes",
      allState: true,
      allLocation: true,
      stateList: [
        "Karnataka",
        "Anthra",
        "kerala",
        "Bangalore",
        "Andhra",
        "Tamil Nadu",
        "test",
        "Tamilnadu",
        "Kerala",
        "Aaaa",
        "Puducherry",
        "VILLUPURAM",
      ],
      locations: [
        "Onsite - Villupuram",
        "Others - Plant / Field / Other Offices",
        "Work From Home",
        "Onsite - Chennai",
        "Onsite - Cuddalore",
        "Onsite - Bengaluru",
      ],
    },
  ];

  const holidayLegendItems = [
    {
      label: "Holiday",
      color: "#092C4C",
      letter: "H",
      boxcolor: "#EEF5FC",
    },
    {
      label: "Restricted Holiday",
      color: "#E3B53E",
      letter: "L",
      boxcolor: "#FEF4DA",
    },
  ];

  const filterComponent = (
    <Filter
      initialValues={{ state: "", location: "", month: "", type: "" }}
      filterOptions={filterOptions}
      buttons={buttons}
      onChange={handleFilterChange}
    />
  );

  const handleMonthChange = (yearMonth) => {
    setSelectedYearMonth(yearMonth);
    console.log(selectedYearMonth, "asdfghjkl;");
  };
  useEffect(() => {}, [allHolidays]);

  return (
    <Box>
      <CardHeader
        header="View All Holiday"
        rightComponent={
          <>
            <Legend
              triggerLabel="Legend"
              legendItems={holidayLegendItems}
              cardWidth={187}
            />
            <IconButton
              sx={{
                color: "#fff",
                width: "40px",
                height: "40px",
                padding: "8.75px 9.21px",
                borderRadius: "4px",
                opacity: 1,
                backgroundColor: "#1677FF",
                margin: "0 10px",
                "&:hover": {
                  backgroundColor: "#0D6EFD",
                },
              }}
              onClick={toggleFilter}
            >
              <FilterAltIcon />
            </IconButton>
          </>
        }
      >
        {/* filter componenet  */}
        {filterVisible && <Box>{filterComponent}</Box>}

        <EventCalendar
          responseData={allHolidays}
          eventContent={eventContent}
          eventClick={handleEventClick}
          onMonthChange={handleMonthChange}
        />

        {selectedEvent && (
          <DialogForm
            title="Holiday Details"
            open={openDialog}
            setOpen={handleCloseDialog}
            width="sm"
            padding={"20px 30px"}
          >
            <ViewHoliday
              event={selectedEvent}
              setOpen={handleCloseDialog}
              setHideBtn={hideBtn}
              handleCloseDialog={handleCloseDialog}
            />
          </DialogForm>
        )}
      </CardHeader>
    </Box>
  );
};

export default ViewAll;
